module.exports = __webpack_public_path__ + "static/media/headshot.9e2fce39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/headshot.jpg
// module id = 109
// module chunks = 0